import { tagTheme, Typography } from '@taglivros/tag-components'
import * as React from 'react'
import * as S from './styles'

const HowItWorksItem = ( { imageAlt, imagePath, secondaryText, title, colorTitle }: HowItWorksItem.Props ): React.ReactElement => {
  return (
    <S.Container className="how-it-works-item">
      <S.Wrapper className="how-it-works-item__wrapper">
        { imagePath &&
          <S.Image
            className="how-it-works-item__image"
            alt={ imageAlt }
            src={ imagePath }
          /> }
        <S.Title className="how-it-works-item__title">
          <Typography
            color={ colorTitle }
            as="p"
            fontFamily="robotoSlab"
            fontWeight="xl"
            fontSizeMobile="l"
            fontSizeDesktop="l"
            variant="customText"
          >
            { title }
          </Typography>
        </S.Title>
      </S.Wrapper>
      <Typography
        as="p"
        fontFamily="notoSans"
        fontWeight="s"
        variant="text3"
        color="GREY-700-TXT"
      >
        { secondaryText }
      </Typography>
    </S.Container>
  )
}

namespace HowItWorksItem {
  export interface Props {
    imageAlt: string
    imagePath: string
    secondaryText: string
    title: string
    colorTitle: keyof typeof tagTheme.cores
  }
}


export default HowItWorksItem

